import React from 'react';
import JsonInputField from '../../../../../Utility/JsonInputField/JsonInputField';

interface SchemaViewerProps {
    title: string;
    schema: any;
}

const SchemaViewer: React.FC<SchemaViewerProps> = ({ title, schema }) => {
    if (!schema) return null;
    return (
        <div>
            <JsonInputField
                label={title}
                value={schema}
                readOnly={true}
                showCopyButton={true}
                minRows={3}
                maxRows={10}
            />
        </div>
    );
};

export default SchemaViewer;
